import React, { forwardRef } from 'react';
import { Dropzone } from '@amigoapp/doca-react';

const FileUpload = forwardRef(({ onFileSelect, maxFiles = 4, acceptedFileTypes = '.pfx', defaultFile }, ref) => {
  return (
    <div className="doca-flex doca-flex-col doca-gap-4">
      <Dropzone
        ref={ref}
        defaultValue={defaultFile}
        draggingLabel="Solte aqui"
        label="Arraste ou clique para anexar arquivos"
        maxFiles={maxFiles}
        onChange={onFileSelect}
        showSelectedFiles
        subtitle={`Arquivos ${acceptedFileTypes}`}
      />
    </div>
  );
});

FileUpload.displayName = 'FileUpload';

export default FileUpload;
